import api from "@/vue-dlb/utils/backend-api";
import ObjDataSet from "@/vue-dlb/models/objdataset";
import ObjTrSet from "@/vue-dlb/models/objtrset";
import appUtil from '@/vue-dlb/utils/app-util'
import config from '@/vue-caas/config/config.js';

const isDlbMybatis = config.isDlbMybatis;

import {
  handleResponseError,
  alertSuccess,
  closeAlert,
  showSuccessMessage,
  showErrorMessage,
  showProgress,
  hideProgress,
  commitRetDataSets
} from "@/vue-dlb/utils/sys-util.js";

import {
  selectDataSetByDataSet,
  selectDataSetByDataSetForComm,
  callByDataSet,
  selectUserDataSet,
} from "@/vue-dlb/utils/backend-util.js";
const state = {
  sysmsg: "",
  sysmsgTitle: "",
  sysmsgText: "",
  sysloading: "",
  sysloadingTitle: "",
  sysalert: "",
  sysalertTitle: "",
  sysalertText: "",
  uploadedFile: "",
  savedFile: "",
  fileContent: "",
  codeList: "",
  bizCodeList: "",
  EDIVerList:"",
  EDIMsgTypeList:"",
  CommMsgList: "",
  blobpdffileurl: "",
  darkMode: true,
  repomenuMode: false,
  // 2021.4.22 203728 Set default when reload page ( not login )
  cmpIdLeftMenu: $cookies.get('comp-id'),
  isDlb: false,
};

const getters = {
};

const actions = {
  UploadFileToServer: async ({ commit }, uploadfile) => {
    console.log('upload File Name:' + uploadfile.data[0].FILE_NAME);
    const retSet = new ObjDataSet("UploadedFile");
    let condSet = new ObjDataSet("condSet");
    let trSet = new ObjTrSet("UploadFileToServer");
    condSet = appUtil.addDataHeader(uploadfile, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet = selectUserDataSet(trSet);   // call directly only for uploading file.
    const formData = new FormData();
    formData.append('file', uploadfile.data[0].file, uploadfile.data[0].FILE_NAME);
    formData.append('trSet', JSON.stringify(trSet));
    await api.trFileSend("Fileupload", formData).then(res => {
      commitRetDataSets(commit, res.data);
    });
  },

  SaveFileToServer: async ({ commit }, savefile) => {
    console.log('save File Name:' + savefile.data[0].FILE_NAME);
    const retSet = new ObjDataSet("SavedFile");
    let condSet = new ObjDataSet("condSet");
    let trSet = new ObjTrSet("SaveFileToServer");
    condSet = appUtil.addDataHeader(savefile, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet = selectUserDataSet(trSet);   // call directly only for uploading file.
    const formData = new FormData();
    formData.append('file', savefile.data[0].file, savefile.data[0].FILE_NAME);
    formData.append('trSet', JSON.stringify(trSet));
    await api.trFileSend("Filesave", formData).then(res => {
      commitRetDataSets(commit, res.data);
    });
  },
  viewFileData: async ({ commit }, fileid) => {
    console.log('path:' + fileid);
    let reqdata =  {FILE_ID: fileid};
    await api.readFile("FileView", reqdata).then(res => {
      // console.log('FILEDATA:' + res.data);
      commit('setFileContent', res.data);
    });
  },
  importEDIData: async ({ commit }, uploadData) => {
    let condSet = new ObjDataSet("condSet");
    let trSet = new ObjTrSet("trSet");
    condSet = new ObjDataSet("condSet");
    trSet = new ObjTrSet("importEDIData");
    condSet = appUtil.addDataHeader(uploadData, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.tranID = "EDIUploadManager";
    trSet.tranMethod = "importEDIData";
    const reqdata = callByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },
  DownloadFileFromServer: async ({ commit }, downloadfile) => {
    console.log('download File Name:' + downloadfile.data[0].SAVE_NAME);
    let condSet = new ObjDataSet("condSet");
    let trSet = new ObjTrSet("DownloadFileFromServer");
    condSet = appUtil.addDataHeader(downloadfile, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    const reqdata = callByDataSet(trSet);
    api.downloadFile("Filedownload", reqdata).then(res => {
      let blob = new Blob([res.data], { type: res.headers['content-type'] })
      let fileName = downloadfile.data[0].SAVE_NAME;
      fileName = decodeURI(fileName) // 파일명 디코딩 (프로젝트에 따라 사용여부 옵션)
      if (window.navigator.msSaveOrOpenBlob) { // IE 10+
        window.navigator.msSaveOrOpenBlob(blob, fileName);
      } else { // not IE
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.target = '_self';
        if (fileName) link.download = fileName;
        link.click();
      }
    })
    .catch(error => {
      if (error.response && typeof error.response.data == 'object') {
        error.response.data = `Error when download ${downloadfile.data[0].SAVE_NAME}`;
      }
    });
  },
  GetBlobUrlPDFFile: async ({ commit }, downloadfile) => {
    console.log('download File Name:' + downloadfile.data[0].SAVE_NAME);
    let condSet = new ObjDataSet("condSet");
    let trSet = new ObjTrSet("GetBlobUrlPDFFile");
    condSet = appUtil.addDataHeader(downloadfile, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    const reqdata = callByDataSet(trSet);
    api.downloadFile("Filedownload", reqdata).then(res => {
      let blob = new Blob([res.data], { type: 'application/pdf' })
      commit('setBlobUrlPDFFile', window.URL.createObjectURL(blob));
    });
  },
  getCode: async ({ commit }, searchItems) => {
    console.log("SearchGroup:" + searchItems.data[0].GRP_CODE);
    const retSet = new ObjDataSet("codeList");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("getCode");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "EDP_COMM_LIST_CODE_LST_FN";
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });
  },
  getBizCode: async ({ commit }, searchItems) => {
    console.log("SearchGroup:" + searchItems.data[0].GRP_CODE);
    const retSet = new ObjDataSet("bizCodeList");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("getBizCode");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "EDP_COMM_LIST_SVC_LST_FN";
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });
  },
  getEDIVersionList: async ({ commit }, searchItems) => {
    const retSet = new ObjDataSet("EDIVerList");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("getEDIVersionList");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "EDP_COMM_LIST_DLB_MSGTYPE_DBVER_FN";
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });
  },
  getEDIMsgTypeList: async ({ commit }, searchItems) => {
    const retSet = new ObjDataSet("EDIMsgTypeList");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("getEDIMsgTypeList");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "EDP_COMM_LIST_DLB_MSGTYPE_MSG_FN";
    let reqdata = ''
    if (isDlbMybatis) reqdata = selectDataSetByDataSetForComm(trSet);
    else reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });
  },
  getCommonMessageList: async ({ commit }, searchItems) => {
    const retSet = new ObjDataSet("CommMsgList");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("getCommonMessageList");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "EDP_COMM_LIST_COMM_MSG_LST_FN";
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });
  }
};
const mutations = {
  UploadedFile (state, datarows) {
    state.uploadedFile = datarows;
    console.log('FileName:' + state.uploadedFile[0].FILE_NAME);
    console.log('FileSize:' + state.uploadedFile[0].FILE_BYTE);
  },
  SavedFile (state, datarows) {
    state.savedFile = datarows;
    console.log('FileName:' + state.savedFile[0].FILE_NAME);
    console.log('FileSize:' + state.savedFile[0].FILE_BYTE);
  },
  setFileContent (state, data) {
    state.fileContent = data;
  },
  codeList (state, datarows) {
    state.codeList = datarows;
  },
  EDIVerList (state, datarows) {
    state.EDIVerList = datarows;
  },
  EDIMsgTypeList(state, datarows){
    state.EDIMsgTypeList = datarows;
  },
  bizCodeList (state, datarows) {
    state.bizCodeList = datarows;
  },
  CommMsgList(state, datarows){
    state.CommMsgList = datarows;
  },
  setSysmsgText (state, text) {
    state.sysmsgText = text;
  },
  setSysmsg (state, sysmsg) {
    state.sysmsg = sysmsg;
  },
  setSysmsgTitle (state, title) {
    state.sysmsgTitle = title;
  },
  setSysloading (state, sysloading) {
    state.sysloading = sysloading;
  },
  setSysloadingTitle (state, title) {
    state.sysloadingTitle = title;
  },
  setSysalert (state, sysalert) {
    state.sysalert = sysalert;
  },
  setSysalertTitle (state, title) {
    state.sysalertTitle = title;
  },
  setSysalertText (state, text) {
    state.sysalertText = text;
  },
  setBlobUrlPDFFile (state, pdf) {
    console.log(" setBlobUrlPDFFile .... ", pdf);
    state.blobpdffileurl = pdf;
  },
  setDarkMode (state, mode) {
    console.log(" setDarkMode .... ", mode);
    state.darkMode = mode;
  },
  setRepoMenuMode (state, mode) {
    console.log(" setRepository Menu .... ", mode);
    state.repomenuMode = mode;
  },
  // 2021.3.25 203728 SPKA-57 issue 26
  setCompanyForLeftMenu (state, id) {
    console.log(" Catch change company for Left menu .... ", id);
    state.cmpIdLeftMenu = id;
  },
  isDlb (state, dlbFlag) {
    state.isDlb = dlbFlag;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
